import React from 'react';

interface JsonViewerProps {
  data: any;
  readOnly?: boolean;
  className?: string;
}

const JsonViewer: React.FC<JsonViewerProps> = ({
  data,
  readOnly: _readOnly = true,
  className = ""
}) => {
  const formattedJson = JSON.stringify(data, null, 2);

  return (
    <div className={`bg-gray-50 rounded-md border ${className}`}>
      <pre className="p-3 text-sm text-gray-700 overflow-auto font-mono whitespace-pre-wrap">
        {formattedJson}
      </pre>
    </div>
  );
};

export default JsonViewer;